/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDiagLabs } from 'app/entities/diag-lab/diag-lab.reducer';
import { getEntities as getDiagLabInventoryTypes } from 'app/entities/diag-lab-inventory-type/diag-lab-inventory-type.reducer';
import { getEntities as getDiagLabInventoryBills } from 'app/entities/diag-lab-inventory-bill/diag-lab-inventory-bill.reducer';
import { createEntity, getEntity, reset, updateEntity } from './diag-lab-inventory.reducer';

export const DiagLabInventoryUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const diagLabs = useAppSelector(state => state.diagLab.entities);
  const diagLabInventoryTypes = useAppSelector(state => state.diagLabInventoryType.entities);
  const diagLabInventoryBills = useAppSelector(state => state.diagLabInventoryBill.entities);
  const diagLabInventoryEntity = useAppSelector(state => state.diagLabInventory.entity);
  const loading = useAppSelector(state => state.diagLabInventory.loading);
  const updating = useAppSelector(state => state.diagLabInventory.updating);
  const updateSuccess = useAppSelector(state => state.diagLabInventory.updateSuccess);

  const handleClose = () => {
    navigate(`/diag-lab-inventory${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDiagLabs({}));
    dispatch(getDiagLabInventoryTypes({}));
    dispatch(getDiagLabInventoryBills({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.stockQty !== undefined && typeof values.stockQty !== 'number') {
      values.stockQty = Number(values.stockQty);
    }
    if (values.manufacDate !== undefined && typeof values.manufacDate !== 'number') {
      values.manufacDate = Number(values.manufacDate);
    }
    if (values.expDate !== undefined && typeof values.expDate !== 'number') {
      values.expDate = Number(values.expDate);
    }
    if (values.mrp !== undefined && typeof values.mrp !== 'number') {
      values.mrp = Number(values.mrp);
    }
    if (values.price !== undefined && typeof values.price !== 'number') {
      values.price = Number(values.price);
    }
    if (values.remainingQuantity !== undefined && typeof values.remainingQuantity !== 'number') {
      values.remainingQuantity = Number(values.remainingQuantity);
    }
    if (values.avgUsesPerItem !== undefined && typeof values.avgUsesPerItem !== 'number') {
      values.avgUsesPerItem = Number(values.avgUsesPerItem);
    }
    if (values.packs !== undefined && typeof values.packs !== 'number') {
      values.packs = Number(values.packs);
    }
    if (values.discount !== undefined && typeof values.discount !== 'number') {
      values.discount = Number(values.discount);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...diagLabInventoryEntity,
      ...values,
      diagLab: diagLabs.find(it => it.id.toString() === values.diagLab?.toString()),
      type: diagLabInventoryTypes.find(it => it.id.toString() === values.type?.toString()),
      bill: diagLabInventoryBills.find(it => it.id.toString() === values.bill?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...diagLabInventoryEntity,
          diagLab: diagLabInventoryEntity?.diagLab?.id,
          type: diagLabInventoryEntity?.type?.id,
          bill: diagLabInventoryEntity?.bill?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.diagLabInventory.home.createOrEditLabel" data-cy="DiagLabInventoryCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.diagLabInventory.home.createOrEditLabel">Create or edit a DiagLabInventory</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="diag-lab-inventory-id"
                  label={translate('tinyMedicRestApp.diagLabInventory.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventory.brandId')}
                id="diag-lab-inventory-brandId"
                name="brandId"
                data-cy="brandId"
                type="text"
                validate={{
                  maxLength: { value: 150, message: translate('entity.validation.maxlength', { max: 150 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventory.batchNumber')}
                id="diag-lab-inventory-batchNumber"
                name="batchNumber"
                data-cy="batchNumber"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <UncontrolledTooltip target="batchNumberLabel">
                <Translate contentKey="tinyMedicRestApp.diagLabInventory.help.batchNumber" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventory.serialNumber')}
                id="diag-lab-inventory-serialNumber"
                name="serialNumber"
                data-cy="serialNumber"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventory.stockQty')}
                id="diag-lab-inventory-stockQty"
                name="stockQty"
                data-cy="stockQty"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventory.manufacDate')}
                id="diag-lab-inventory-manufacDate"
                name="manufacDate"
                data-cy="manufacDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventory.expDate')}
                id="diag-lab-inventory-expDate"
                name="expDate"
                data-cy="expDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventory.taxCode')}
                id="diag-lab-inventory-taxCode"
                name="taxCode"
                data-cy="taxCode"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventory.mrp')}
                id="diag-lab-inventory-mrp"
                name="mrp"
                data-cy="mrp"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventory.price')}
                id="diag-lab-inventory-price"
                name="price"
                data-cy="price"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventory.remainingQuantity')}
                id="diag-lab-inventory-remainingQuantity"
                name="remainingQuantity"
                data-cy="remainingQuantity"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventory.avgUsesPerItem')}
                id="diag-lab-inventory-avgUsesPerItem"
                name="avgUsesPerItem"
                data-cy="avgUsesPerItem"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventory.packs')}
                id="diag-lab-inventory-packs"
                name="packs"
                data-cy="packs"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventory.HSNCode')}
                id="diag-lab-inventory-HSNCode"
                name="HSNCode"
                data-cy="HSNCode"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventory.rack')}
                id="diag-lab-inventory-rack"
                name="rack"
                data-cy="rack"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventory.discount')}
                id="diag-lab-inventory-discount"
                name="discount"
                data-cy="discount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventory.active')}
                id="diag-lab-inventory-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventory.cursor')}
                id="diag-lab-inventory-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventory.lastUpdated')}
                id="diag-lab-inventory-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventory.microSec')}
                id="diag-lab-inventory-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diagLabInventory.timestampEntry')}
                id="diag-lab-inventory-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="diag-lab-inventory-diagLab"
                name="diagLab"
                data-cy="diagLab"
                label={translate('tinyMedicRestApp.diagLabInventory.diagLab')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabs
                  ? diagLabs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="diag-lab-inventory-type"
                name="type"
                data-cy="type"
                label={translate('tinyMedicRestApp.diagLabInventory.type')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabInventoryTypes
                  ? diagLabInventoryTypes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="diag-lab-inventory-bill"
                name="bill"
                data-cy="bill"
                label={translate('tinyMedicRestApp.diagLabInventory.bill')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabInventoryBills
                  ? diagLabInventoryBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/diag-lab-inventory" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DiagLabInventoryUpdate;
